import React from 'react'
import { IconProps } from './icons.models'

export const RefreshIcon: React.FC<IconProps> = ({
    width = 16,
    height = 16,
    fillColor = '#155DFC',
    className,
    onClick,
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_385_2832)">
                <path d="M15.4321 2.20716C15.0883 2.17581 14.7843 2.42909 14.753 2.77284L14.6701 3.68125C13.2652 1.47481 10.8263 0 8.0004 0C4.96037 0 2.28127 1.73506 0.951334 4.33919C0.794334 4.64659 0.916272 5.02306 1.22368 5.18006C1.53115 5.33706 1.90755 5.21516 2.06455 4.90772C3.19008 2.70384 5.4503 1.25 8.0004 1.25C10.3247 1.25 12.4222 2.46034 13.6239 4.3565L12.7328 3.72003C12.4519 3.51944 12.0615 3.5845 11.8609 3.86538C11.6603 4.14628 11.7254 4.53659 12.0063 4.73722L14.7086 6.66725C15.1047 6.94959 15.651 6.69112 15.6943 6.21541L15.9977 2.88634C16.0291 2.54256 15.7759 2.2385 15.4321 2.20716Z" fill={fillColor} />
                <path d="M14.7767 10.8207C14.4692 10.6637 14.0928 10.7856 13.9358 11.0931C12.8103 13.2969 10.5501 14.7508 7.99997 14.7508C5.67568 14.7508 3.57812 13.5404 2.37643 11.6443L3.26759 12.2807C3.5485 12.4813 3.93881 12.4163 4.13943 12.1354C4.34003 11.8545 4.27497 11.4642 3.99409 11.2636L1.29175 9.33353C0.900528 9.05403 0.349841 9.30474 0.306091 9.78537L0.00262212 13.1144C-0.0287216 13.4582 0.22456 13.7622 0.568278 13.7936C0.912466 13.8249 1.21612 13.5713 1.24743 13.2279L1.33025 12.3195C2.73518 14.526 5.17406 16.0008 7.99997 16.0008C11.04 16.0008 13.7191 14.2657 15.049 11.6616C15.206 11.3542 15.0841 10.9777 14.7767 10.8207Z" fill={fillColor} />
            </g>
            <defs>
                <clipPath id="clip0_385_2832">
                    <rect width={width} height={height} fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
